import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'

const usePageTracking = () => {
  const location = useLocation()
  const fullPath = location.pathname + location.search
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: fullPath,
      title: document.title,
    })
    // if (typeof window.gtag !== 'undefined') {
    //   window.gtag('config', process.env.REACT_APP_GA4_MEASUREMENT_ID, {
    //     page_path: fullPath,
    //     page_title: document.title,
    //   })
    // }
  }, [location])
}

export default usePageTracking
